const attributions = {
  getlist: 'AdsAttribution/getlist',
  getAll: 'AdsAttribution/getall',
  get: 'AdsAttribution/get',
  add: 'AdsAttribution/add',
  update: 'AdsAttribution/update',
  remove: 'AdsAttribution/remove',
  matrixReport: 'Attribution/metrix-getList',
  adtraceReport: 'Attribution/adtrace-getList',
  report: 'AdsAttribution/get-report',
}
export default attributions
